cb.define(['common/common_VM.Extend.js'], function (common) {

    var PM_pmc_promotionlist_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            var gridModel = viewmodel.getGridModel();

            viewmodel.on('beforeEdit', function (args) {
                var index = args.params.params.index;
                var id = viewmodel.getAllData().pmc_promotionlist[index].id;
                var params = {
                    mode: 'edit',
                    readOnly: false,
                    id: id
                };
                var data = {
                    billtype: 'voucher',
                    billno: common.getBillNo(viewmodel.getAllData().pmc_promotionlist[index].type),
                    params: params
                };
                if (cb.rest.AppContext.user.userType == 0) {
                    cb.loader.runCommandLine('bill', data, viewmodel);
                } else {
                    common.checkAuthDo(id, data.billno).then((result) => {
                        //result为服务返回结果
                        //成功走这
                        cb.loader.runCommandLine('bill', data, viewmodel);
                    }).catch(() => {
                        //失败走这
                    });
                }
                return false;
            });

            // viewmodel.on("beforeBatchdelete", function(args) {
            //     var index = args.params.params.index;
            //     return false;
            // });

            viewmodel.on("beforeBatchdo", function (data) {
                data.data.data = JSON.stringify(this.getGridModel().getSelectedRows());
            });

            gridModel.on('beforeDblClick', function (args) {
                if (args.id) {
                    let params = {
                        mode: 'browse',
                        readOnly: true,
                        id: args.id
                    };
                    var data = {
                        billtype: 'voucher',
                        billno: common.getBillNo(args.rowData.type),
                        params: params
                    };
                    cb.loader.runCommandLine('bill', data, viewmodel)
                }
                return false;
            });

            gridModel.on('afterSetDataSource', () => {
                const rows = gridModel.getRows();
                const actions = gridModel.getCache('actions');
                const actionsStates = [];
                rows.forEach(data => {
                    const actionState = {};
                    actions.forEach(action => {
                        if (action.cItemName == "btnDisAble") {

                            if (data.valid == 1) {
                                actionState[action.cItemName] = {visible: true};
                            } else {
                                actionState[action.cItemName] = {visible: false};
                            }
                        } else if (action.cItemName == "btnEnAble") {
                            if (data.valid == 0) {
                                actionState[action.cItemName] = {visible: true};
                            } else {
                                actionState[action.cItemName] = {visible: false};
                            }
                        } else {
                            actionState[action.cItemName] = {visible: true};
                        }
                    });
                    actionsStates.push(actionState);
                });
                gridModel.setActionsState(actionsStates);
            });

            //批量设置分类
            //促销分类字段所在的隐藏的viewmodel
            var classReferModel = new cb.models.ReferModel({
                cRefType: 'pmc_promotionclassref',
                multiple: false
            });
            viewmodel.addProperty('promotionClassRef', classReferModel);
            classReferModel.setVisible(false)
            //加入促销分类的批量操作
            viewmodel.on('batchSetClass', function (args) {
                classReferModel.setCache('args', args);
                classReferModel.setCondition({});
                classReferModel.browse(true);
            });
            //设置促销分类之前判断是否选择促销活动
            classReferModel.on('beforeBrowse', function (data) {
                var selectedRows = gridModel.getSelectedRows();
                if (selectedRows == undefined || selectedRows.length == 0) {
                    cb.utils.alert('未选择促销活动', 'warning');
                    return false;
                }
            });
            //判断是否选择促销分类
            classReferModel.on('afterValueChange', function (args) {
                var selectedRows = gridModel.getSelectedRows();
                Object.assign(args, this.getCache('args'));
                if (args && args.value && !args.value.id) {
                    cb.utils.alert('未选择促销分类', 'warning');
                    return false
                }
                let promotionClass = args.value.id;
                var datas = [];
                for (var i = 0; i < selectedRows.length; i++) {
                    datas.push({
                        "id": selectedRows[i]["id"],
                        "type": selectedRows[i]["type"],
                        'promotionClass': promotionClass
                    });
                }
                Ajax(args, datas)
            })

            const Ajax = (args, datas) => {
                var proxy = cb.rest.DynamicProxy.create({
                    ensure: {
                        url: args.cSvcUrl,
                        method: args.cHttpMethod
                    }
                });
                var params = {
                    billnum: "pmc_promotionlist",
                    action: args.cAction,
                    data: JSON.stringify(datas)
                }
                proxy.ensure(params, function (err, result) {
                    if (err) {
                        cb.utils.alert(err.message, 'error');
                        return;
                    }
                    let {
                        failCount,
                        messages,
                        sucessCount
                    } = result;
                    if (sucessCount) {
                        cb.utils.alert(args.cShowCaption + '成功' + sucessCount + '条', 'success');
                    }
                    if (failCount !== undefined) {
                        messages.forEach(v => {
                            cb.utils.alert(v, 'warning');
                        })
                        viewmodel.execute('back');
                        return false
                    }
                    cb.utils.alert("操作成功", 'success');
                    viewmodel.execute('back');
                });
            }

        }
    };
    try {
        module.exports = PM_pmc_promotionlist_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_promotionlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_promotionlist_VM.Extend.js